'use es6';

import UsersAndTeamsData from 'AdsUI/data/UsersAndTeamsData';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
export function fetchUsersInfo() {
  return dispatch => wrapReduxAction(UsersAndTeamsData.getUsers, 'USERS_INFO_FETCH', {
    dispatch
  });
}
export function fetchTeamsInfo() {
  return dispatch => wrapReduxAction(UsersAndTeamsData.getTeams, 'TEAMS_INFO_FETCH', {
    dispatch
  });
}